import { Component, OnInit } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import "rxjs/add/operator/map";
import { LocalStorageService } from "ngx-store";
@Component({
  selector: "app-img-preview",
  templateUrl: "./img-preview.component.html",
  styleUrls: ["./img-preview.component.css"]
})
export class ImgPreviewComponent implements OnInit {
  itemsRefIMG;
  itemsImageLists = [];
  height = [];
  width = [];
  verify;
  loader;
  path;
  itemsRefIMGBp;
  preview;
  constructor(
    private afd: AngularFireDatabase,
    private ls: LocalStorageService
  ) {
    if ((this.ls.get("username") == "psm") || (this.ls.get("username") == "mad")) {
      this.itemsRefIMG = afd.list("psimagetest");
      this.itemsRefIMGBp = afd.list("psimagetestBackup");
      this.path = "psimagetest";
    } else {
      this.verify = true;
      this.itemsRefIMG = afd.list("sampleImg");
      this.path = "sampleImg";
    }
  }

  ngOnInit() {
    this.loader = true;
    this.itemsRefIMG.valueChanges().subscribe(imgList => {
      this.loader = false;
      console.log("courses", imgList); // Check the returned values;
      this.itemsImageLists = imgList;
      if (this.itemsImageLists) {
        for (let i = 0; i < this.itemsImageLists.length; i++) {
          this.height[i] = 250;
          this.width[i] = 250;
        }
      }
    });
    console.log(" ds", this.itemsImageLists);
    this.getPeople();
  }

  code() {
    const data = (<HTMLInputElement>document.getElementById("code")).value;
    if (data == "4200") {
      this.verify = true;
    } else {
      this.verify = false;
    }
    (<HTMLInputElement>document.getElementById("code")).value = "";
  }

  getPeople() {
    return new Promise<any>((resolve, reject) => {
      this.afd
        .list(this.path)
        .snapshotChanges()
        .subscribe(changes => {
          changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
          console.log(" changes", changes);
          resolve(changes);
        });
    });
  }

  encodeImageFileAsURL(element) {
    var file = element.target.files[0];
    console.log("sss");
    const formData: FormData = new FormData();
    formData.append('sample', file);
    console.log("data", formData);
    // var reader = new FileReader();
    // reader.onload = e => {
    //   this.ls.set("psimg", reader.result);
    //   console.log("s",reader.result)
    // };
    this.preview = this.ls.get("psimg");
    // this.uploadstatus = 'uploading....';
    // if (this.preview) {
    //   this.itemsRefIMG.push({
    //     img: this.preview
    //   });
    //   if ((this.ls.get("username") == "psm") || (this.ls.get("username") == "mad") ) {
    //     this.itemsRefIMGBp.push({
    //       img: this.preview
    //     });
    //   }
    //   element.target.value = [];
    // }
    // reader.readAsDataURL(file);
    element.target.value = [];
    this.preview = "";
    this.ls.set("psimg", "");
  }

  zoomIn(i) {
    this.width[i] = this.width[i] + 3;
    this.height[i] = this.height[i] + 3;
  }

  zoomOut(i) {
    this.width[i] = this.width[i] - 3;
    this.height[i] = this.height[i] - 3;
  }

  deleteEverything() {
    this.itemsRefIMG.remove();
  }
  
}
